/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DetailsAction/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaButtonWithText from 'DesignSystem/TysiaButtonWithText/index'



/** @type {import('Simple/types.js').View} */
export default function DetailsAction({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/New/SimilarPatients/Content/Content/SimilarPerson/Lead/DetailsAction"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
  return (<React.Fragment
>
<TysiaButtonWithText
  viewPath={`${viewPath}/TysiaButtonWithText`}
 size="small"
 alignSelf="center"
 type="secondary"
 text="View Details"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../Details/Content'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../Details/Content'))}
/>
{children}
</React.Fragment>)
}